import styles from './MetricCard.module.css'

export interface MetricCardProps {
  value: string
  label: string
  /** e.g. "25/48 verified", "oldest: 34 min" — never a bare trend arrow (Phase 5 review notes). */
  detail: string
  onClick?: () => void
}

/**
 * UI spec §2's Home metric card. Deliberately takes a pre-formatted
 * `detail` string rather than a numerator/denominator pair itself — Phase 5
 * decides exactly how each of the four metrics phrases its detail line
 * (`HomeAggregates` in `@console/types` carries the raw numbers); this
 * primitive only lays out whatever it's given.
 */
export function MetricCard({ value, label, detail, onClick }: MetricCardProps) {
  return (
    <button type="button" className={styles['card']} onClick={onClick}>
      <span className={styles['value']}>{value}</span>
      <span className={styles['label']}>{label}</span>
      <span className={styles['detail']}>{detail}</span>
    </button>
  )
}
